export default __webpack_public_path__ + "static/media/3d-secure.0f5be7f8.png";